export interface ISelectItem {
    _id: string;
    value?: string;
    label: string;
    active?: boolean;
    description?: string;
}

export interface SelectGroup {
    name: string;
    items: ISelectItem[];
}

export class SelectItem implements ISelectItem {
    _id: string;
    label: string;
    constructor(_id: string, label?: string) {
        (this._id = _id), (this.label = label || '');
    }
}

export const ISELECT_NULL = {
    _id: null,
    label: null,
    value: null,
};
